<template>
  <div class="Debug" v-if="panicking">
    <OverlayWindow v-on:done="panicking = false">
      <template v-slot:title
        ><b>Server {{ title }}:</b></template
      >
      <pre v-html="message"></pre>
      <button class="borderless round closeOverlay" @click="panicking = false">
        <IconX color="#000" stroke="2" size="24" />
      </button>

      <template v-slot:actions>
        <button v-on:click="panicking = false">OK</button>
        <button v-on:click="reload()">Reload</button>
      </template>
    </OverlayWindow>
  </div>
</template>

<script>
//import {mapState, mapActions, mapGetters} from 'vuex'
import OverlayWindow from '../OverlayWindow/OverlayWindow.vue'
import { IconX } from '@tabler/icons-vue'

export default {
  name: 'DebugComponent',
  data() {
    return {
      title: 'Panic',
      panicking: false,
      message: '',
      trace: '',
    }
  },
  components: { OverlayWindow, IconX },
  computed: {},
  methods: {
    setDebug(event) {
      this.title = 'Debug'
      this.panicking = true
      this.message = event.detail
      this.stack = ''
    },
    reload() {
      window.location.reload()
    },
  },
  unmounted() {
    window.removeEventListener('ws:panic', this.setDebug)
    window.removeEventListener('ws:debug', this.setDebug)
  },
  created() {
    window.addEventListener('ws:panic', this.setDebug)
    window.addEventListener('ws:debug', this.setDebug)
  },
}
</script>

<style lang="scss" scoped>
.Debug {
  position: relative;
  z-index: 1000;
}
.Debug:deep(pre) {
  text-align: left;
  font-size: 12px;
}
.stack {
  white-space: pre;
  font-family: monospace;
  text-align: left !important;
}

.closeOverlay {
  position: absolute;
  top: calc(var(--sp) * 2.5);
  right: 0;
}
</style>
